import { MEDIA_QUERY_ACTION_TYPE } from '@models/mediaQueryWatcher';

export default function mediaQueryWatcher(state = {}, action) {
  if (action.type !== MEDIA_QUERY_ACTION_TYPE) return state;
  return { ...state, ...action.payload };
}
